import RestResource from '../rest.service';

export default class VarietiesService extends RestResource {
  map(payload) {
    return {
      name: payload.name,
      description: payload.description,
      crop_id: payload.crop,
      for_sale: payload.forSale,
    };
  }

  constructor() {
    super('varieties');
  }
}
